import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TestHooks } from './enter-policy-details.hooks';

@Component({
	selector: 'app-enter-policy-details',
	templateUrl: './enter-policy-details.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class EnterPolicyDetailsComponent implements OnInit {
	testHooks = TestHooks;

	ngOnInit(): void {}
}
